export { default } from "./XAxisTick";
